<template>
	<v-dialog width="750px">
		<template v-slot:activator="{ on }">
			<v-btn class="customVBtn" v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>error</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">STATE</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<v-row>
				<v-col>
					<v-btn	class="customVBtn"
							block
							color="white"
							depressed
							@click="$_dbgDlg_refresh()">
						<v-icon>refresh</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row class="px-2" align="center">
				<v-col>
					<v-radio-group
							class="mergin_"
							v-model="checked_"
							row hide-details>
						<template v-for="key in debug_">
							<v-radio 
									class="radio_"
									color="error"
									:key="key"
									:label="key"
									:value="key" />
						</template>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row class="px-2">
				<v-col>
					<v-alert
							class="customVAlert"
							color="error"
							outlined>
						<pre	class="prettyprint caption pretty_"
								v-text="model_[checked_]" />
					</v-alert>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'DebuggerDialog',
		data() {
			return {
				debug_: [
					'Moment',
					'Cookie',
					'CurrentUser',
					'Route',
					'App',
					'Component',
					'Page',
					'Csv',
					'Input',
					'Message',
					'User',
					'Contents',
					'Inits',
					'Langs',
					'Styles',
					'Messages',
					'Point',
					'Recruits',
					'Sales',
					'Trainings',
					'Admin'
				],

				checked_: 'None',
				
				model_: {
					None: 'Not Selected'
				}
			}
		},
		computed: {
			// state
			$_dbgDlg_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			}
		},
		created() {
			const self_ = this;

			self_.$_dbgDlg_refresh()
		},
		methods: {
			$_dbgDlg_refresh() {
				const self_ = this;
				const route_ = self_.$route;

				const routeObj_ = {
					name: route_.name,
					path: route_.path,
					params: route_.params
				}

				self_.model_.Moment = self_.moment(new Date())
				self_.model_.Cookie = self_.jsCookie.get()
				self_.model_.CurrentUser = self_.getCurrentUser()
				self_.model_.Route = routeObj_;

				self_.model_.App = self_.getState('app')
				self_.model_.Component = self_.getState('component')
				self_.model_.Page = self_.getState('page')
				self_.model_.Csv = self_.getState('csv')
				self_.model_.Input = self_.getState('input')
				self_.model_.Message = self_.getState('message')
				self_.model_.User = self_.getState('user')
				self_.model_.Contents = self_.getState('contents')
				self_.model_.Inits = self_.getState('inits')

				self_.model_.Langs = self_.getLocalStorage('langs')
				self_.model_.Styles = self_.getLocalStorage('styles')

				self_.model_.Point = self_.getState('point')
				self_.model_.Recruitments = self_.getState('recruitments')
				self_.model_.Sales = self_.getState('sales')
				self_.model_.Trainings = self_.getState('trainings')
				self_.model_.Admin = self_.getState('admin')

				self_.checked_ = 'None';
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
	.mergin_ {
		margin-top: 0;
		margin-bottom: 0;
	}
	.pretty_ {
		border: none;
		color: #ff5252;
	}
</style>
